module.exports = __webpack_public_path__ + "static/media/tr2.058a8031.png";